var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('b-loading',{attrs:{"active":_vm.routeLoading},on:{"update:active":function($event){_vm.routeLoading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }